import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from '@emotion/styled';
import { Tag } from 'antd';
import { css } from '@emotion/core';
import { withBreakpoints } from 'react-breakpoints';
import DiscoverById from '../../components/DiscoverById';
import DiscoverByURL from '../../components/DiscoverByUrl';
import CommonButton from '../common/Button';
import IconSvg from '../common/IconSvg';
import { RowFlex } from '../common/FlexStyle';
import { getIdForUrl } from '../../utils/Discover';
import { getSplitString, getSplitStringBySpace } from '../../utils/parsers';
import Checkbox from '../common/Checkbox';
import ENUMS from '../../constants/enums';
import { fontSize } from '../../constants';

const StyledSeperator = styled('div')`
  width: 10%;
  font-size: 20px;
  display: flex;
  justify-content: space-around;
  position: relative;
  margin: 0 10px 0 10px;
`;
@inject('enumsStore')
@inject('sessionStore')
@injectIntl
@observer
class DiscoverInputs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: props.discoverValueString,
      csvIdsArray: [],
      updatedBy: props.discoveryMethod || null,
      isErrorOnUrl: false,
    };
  }

  /**
   * updating the state on change.
   * @param {eNum} updatedBy which component update it
   */
  onChangeUpdate = (e, updatedBy, form) => {
    if (!e.target) {
      this.setState({ csvIdsArray: e, updatedBy });
    } else {
      this.setState(
        {
          searchValue: e.target.value,
          updatedBy: e.target.value.length > 0 ? updatedBy : null,
        },
        () => {
          if (form) {
            form.validateFields(err => {
              if (err) {
                this.setState({ isErrorOnUrl: true });
              } else {
                this.setState({ isErrorOnUrl: false });
              }
            });
          }
        },
      );
    }
  };

  /**
   * splitting and parsing the ids string in to object,
   * setting the store and route to next step
   */
    setSearchValue = () => {
    let splitedValues = null;
    const {
      setDiscoverValue,
      setDiscoverMethod,
      setDiscoverValueString,
      discoverSourceId,
    } = this.props;
    setDiscoverValueString(this.state.searchValue);
    if (this.state.updatedBy === ENUMS.COMMON.ID) {
      if (this.state.searchValue) {
        splitedValues = getSplitString(this.state.searchValue);
      } else {
        splitedValues = this.state.csvIdsArray;
      }
    } else {
      splitedValues = getSplitStringBySpace(this.state.searchValue);
      splitedValues = getIdForUrl(splitedValues, discoverSourceId, ENUMS.SOURCE_MARKETPLACE);
    }
    const data = splitedValues.map(val => ({
      id: val,
      title: null,
    }));
    setDiscoverValue(data);
    setDiscoverMethod(this.state.updatedBy);
  };

  render() {
    const {
      setDiscoverMethod,
      setDiscoverValue,
      browserHistory,
      isDisabled,
      discoverValueString,
      enumsStore,
      discoverSourceId,
      isWithVariations,
      setIsWithVariations,
      automaticallyListItems,
      setAutomaticallyListItems,
      setSkipVeroValidation,
      skipVeroValidation,
      afterChange = () => {},
      buttonContent,
      useCollageImage,
      setUseCollageImage,
      rotateImage,
      setRotateImage,
      skipOptimization,
      setSkipOptimization,
      sessionStore: { isNonApi },
    } = this.props;

    const { breakpoints, currentBreakpoint } = this.props;

    return (
      <div
        className="discoverInputsWrapper"
        css={css`
          padding-top: 10px;
          padding-bottom: 10px;
          ${breakpoints[currentBreakpoint] < breakpoints.tablet && 'margin-top: 70px;'}
        `}
      >
        {!isDisabled && !isNonApi && (
          <RowFlex style={{ alignSelf: 'flex-start', fontSize: fontSize.medium }}>
            <Checkbox
              checked={automaticallyListItems}
              onChange={e => {
                setAutomaticallyListItems(e.target.checked);
              }}
              table
            />
            <span style={{ marginLeft: '10px' }}>
              <FormattedMessage
                id="discover.listItemsAutomatically"
                defaultMessage="Automatically list discovered items"
              />
            </span>
            <Tag
              color="green"
              css={css`
                line-height: 2;
                cursor: auto;
              `}
            >
              NEW
            </Tag>
          </RowFlex>
        )}
        {!isDisabled && !isNonApi && (
          <RowFlex style={{ alignSelf: 'flex-start', fontSize: fontSize.medium }}>
            <Checkbox
              checked={isWithVariations}
              onChange={e => {
                setIsWithVariations(e.target.checked);
              }}
              table
            />
            <span style={{ marginLeft: '10px' }}>
              <FormattedMessage
                id="discover.includeVariationsForDiscover"
                defaultMessage="Include Item Variations in the Discovery"
              />
            </span>
          </RowFlex>
        )}
        {!isDisabled && (
          <RowFlex style={{ alignSelf: 'flex-start', fontSize: fontSize.medium }}>
            <Checkbox
              checked={skipVeroValidation}
              onChange={e => {
                setSkipVeroValidation(e.target.checked);
              }}
              table
            />
            <span style={{ marginLeft: '10px' }}>
              <FormattedMessage id="discover.skipVeroCheck" defaultMessage="Skip VERO check" />
            </span>
          </RowFlex>
        )}
        {!isDisabled && (
          <RowFlex style={{ alignSelf: 'flex-start', fontSize: fontSize.medium }}>
            <Checkbox
              checked={skipOptimization}
              onChange={e => {
                setSkipOptimization(e.target.checked);
              }}
              table
            />
            <span style={{ marginLeft: '10px' }}>
              <FormattedMessage id="discover.skipOptimization" defaultMessage="Skip Optimization" />
            </span>
          </RowFlex>
        )}
        {!isDisabled && (
          <RowFlex style={{ alignSelf: 'flex-start', fontSize: fontSize.medium }}>
            <Checkbox
              checked={useCollageImage}
              onChange={e => {
                setUseCollageImage(e.target.checked);
              }}
              table
            />
            <span style={{ marginLeft: '10px' }}>
              <FormattedMessage
                id="discover.useCollage"
                defaultMessage="Add collage as main image"
              />
            </span>
          </RowFlex>
        )}
        {!isDisabled && (
          <RowFlex style={{ alignSelf: 'flex-start', fontSize: fontSize.medium, marginBottom: 10 }}>
            <Checkbox
              checked={rotateImage}
              onChange={e => {
                setRotateImage(e.target.checked);
              }}
              table
            />
            <span style={{ marginLeft: '10px' }}>
              <FormattedMessage id="discover.rotateImage" defaultMessage="Rotate main image" />
            </span>
          </RowFlex>
        )}

        <div
          className="discoverInputs"
          css={css`
            ${breakpoints[currentBreakpoint] < breakpoints.tablet && 'flex-direction:column;'}
          `}
        >
          <DiscoverByURL
            handleSubmit={this.setSearchValue}
            onEnter={() => {
              if (
                (this.state.updatedBy && !this.state.isErrorOnUrl) ||
                this.state.updatedBy === enumsStore.enums.DISCOVERY_METHODS.IDS
              ) {
                this.setSearchValue();
                afterChange();
              }
            }}
            onChangeUpdate={this.onChangeUpdate}
            isDisabled={this.state.updatedBy === ENUMS.COMMON.ID}
            isDisabledByStep={isDisabled}
            updatedBy={this.state.updatedBy}
            setDiscoverValue={setDiscoverValue}
            discoverValueString={discoverValueString}
            discoverSourceId={discoverSourceId}
          />
          <StyledSeperator>
            <IconSvg
              type="arrow-l"
              width={20}
              height={10}
              style={{ top: '8px', position: 'relative' }}
            />
            <span>OR</span>
            <IconSvg
              type="arrow-r"
              width={20}
              height={10}
              style={{ top: '8px', position: 'relative' }}
            />
          </StyledSeperator>
          <DiscoverById
            setDiscoverMethod={setDiscoverMethod}
            setDiscoverValue={setDiscoverValue}
            browserHistory={browserHistory}
            onChangeUpdate={this.onChangeUpdate}
            isDisabled={this.state.updatedBy === ENUMS.COMMON.URL}
            updatedBy={this.state.updatedBy}
            isDisabledByStep={isDisabled}
            discoverValueString={discoverValueString}
          />
        </div>
        <RowFlex
          css={css`
            justify-content: flex-start;
            width: 100%;
            padding-left: 3%;
            margin-top: 10px;
            ${breakpoints[currentBreakpoint] < breakpoints.tablet &&
              'justify-content: center; padding-left: 0px;'}
          `}
        >
          {(this.state.updatedBy && !this.state.isErrorOnUrl) ||
          this.state.updatedBy === enumsStore.enums.DISCOVERY_METHODS.IDS ? (
            <div>
              <FormattedMessage id="common.pressEnterOr" defaultMessage="Press ENTER Or" />
              <CommonButton
                disabled={isDisabled}
                clickHandler={() => {
                  this.setSearchValue();
                  afterChange();
                }}
                cssProps={{ marginLeft: '20px' }}
              >
                {buttonContent || (
                  <FormattedMessage id="common.continue" defaultMessage="continue" />
                )}
              </CommonButton>
            </div>
          ) : (
            <div style={{ height: '30px' }} />
          )}
        </RowFlex>
      </div>
    );
  }
}

DiscoverInputs.propTypes = {
  setDiscoverMethod: PropTypes.func,
  setUseCollageImage: PropTypes.func,
  useCollageImage: PropTypes.bool,
  setRotateImage: PropTypes.func,
  rotateImage: PropTypes.bool,
  setSkipOptimization: PropTypes.func,
  skipOptimization: PropTypes.bool,
  discoveryMethod: PropTypes.number,
  discoverValueString: PropTypes.string,
  setDiscoverValue: PropTypes.func,
  setDiscoverValueString: PropTypes.func,
  browserHistory: PropTypes.object,
  isDisabled: PropTypes.bool,
  enumsStore: PropTypes.object,
  sessionStore: PropTypes.object,
  discoverSourceId: PropTypes.number,
  isWithVariations: PropTypes.bool,
  setIsWithVariations: PropTypes.func,
  setSkipVeroValidation: PropTypes.func,
  skipVeroValidation: PropTypes.bool,
  afterChange: PropTypes.func,
  buttonContent: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
};

export default withBreakpoints(DiscoverInputs);
